import { render, staticRenderFns } from "./PlaylistsEditTabContent.vue?vue&type=template&id=d47b9c48&scoped=true&"
import script from "./PlaylistsEditTabContent.vue?vue&type=script&lang=js&"
export * from "./PlaylistsEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistsEditTabContent.vue?vue&type=style&index=0&id=d47b9c48&prod&lang=scss&scoped=true&"
import style1 from "./PlaylistsEditTabContent.vue?vue&type=style&index=1&id=d47b9c48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47b9c48",
  null
  
)

export default component.exports